var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isScreenshotMode)?_c('div',{class:{
    absolute: true,
    'z-10': true,
    'top-0 ltr:right-0 rtl:left-0': true,
    group: true,
    'ltr:rounded-tr-xl rtl:rounded-tl-xl': true,
  }},[_c('div',[_c('div',{class:{
        'h-[29px] w-min': true,
        relative: true,
        flex: true,
        'ltr:pl-1 rtl:pr-1': true,
        'overflow-visible': _setup.isTouchable,
      }},[(_setup.xEditPost)?_c('div',{class:{
          'transition-transform': true,
          'translate-x-0': _setup.isEditButtonFocused,
          'ltr:translate-x-full rtl:-translate-x-full group-hover:translate-x-0': !_setup.isEditButtonFocused,
          'ltr:rounded-bl-lg rtl:rounded-br-lg': true,
          'ltr:pr-[9px] rtl:pl-[9px]': true,
          'pt-[3px] ltr:mr-[-8px] rtl:ml-[-8px]': true,
          'flex justify-start items-start': true,
          [_setup.bgColorClass]: true,
        }},[(_vm.xOverlay && !_setup.isWishContentScrollable)?_c('div',{class:{
            absolute: true,
            'ltr:left-[-4px] rtl:right-[-4px] top-[7px]': !_setup.isStream,
            'ltr:left-[-4px] rtl:right-[-4px] top-[11px]': _setup.isStream,
            'rtl:-scale-x-100': true,
            [_setup.cornerColorClass]: true,
          }}):_vm._e(),_vm._v(" "),_c(_setup.OzPlainButton,{class:[
            'font-semibold',
            'text-body-extra-small',
            'py-0',
            'px-1.5',
            'h-4',
            'mt-[5px]',
            'mb-[5px]',
            // Focus
            _vm.colorScheme === 'light' && 'focus-visible:text-grape-500',
            _vm.colorScheme === 'dark' && 'focus-visible:text-canary-500',
          ],attrs:{"color-scheme":_setup.OzPlainButtonColorScheme.SecondaryIcon,"dark-mode":_vm.colorScheme === 'dark',"size-preset":null,"text":_vm.__('Edit'),"aria-label":_vm.__('Edit this post')},on:{"click":function($event){return _vm.$emit('edit')},"focus":function($event){_setup.isEditButtonFocused = true},"blur":function($event){_setup.isEditButtonFocused = false}}})],1):_vm._e(),_vm._v(" "),(_setup.xEditPost)?_c('div',{class:{
          'z-20': true,
          'opacity-0': !_vm.xFillerElements || !_setup.isEditButtonFocused || _setup.isMoreActionsButtonFocused,
          'opacity-100': _vm.xFillerElements && _setup.isEditButtonFocused,
          'group-hover:opacity-100': _vm.xFillerElements && !_setup.isEditButtonFocused && !_setup.isMoreActionsButtonFocused,
          'transition-opacity': true,
          'h-4 mt-[8px] mb-[5px]': true,
          'w-[0px]': true,
          'border-r-[0.5px] border-solid': true,
          'border-dark-text-400': _vm.colorScheme === 'light',
          'border-light-text-400': _vm.colorScheme === 'dark',
        }}):_vm._e(),_vm._v(" "),_c('div',{class:{
          'w-5.5 pt-[3px] h-[26px]': true,
          flex: true,
          relative: true,
          'overflow-visible': true,
          'justify-end': true,
          'ltr:rounded-bl-lg rtl:rounded-br-lg': true,
          [_setup.bgColorClass]: true,
        }},[(_vm.xOverlay && !_setup.isWishContentScrollable)?_c('div',{class:[
            {
              absolute: true,
              'ltr:left-[-4px] rtl:right-[-4px] top-[7px]': !_setup.isStream,
              'ltr:left-[-4px] rtl:right-[-4px] top-[11px]': _setup.isStream,
              'rtl:-scale-x-100': true,
              [_setup.cornerColorClass]: true,
            },
            {
              'opacity-0': !_vm.xFillerElements || (_setup.xEditPost && _setup.isEditButtonFocused) || _setup.isMoreActionsButtonFocused,
              'transition opacity-100 group-hover:opacity-0':
                _vm.xFillerElements && _setup.xEditPost && !_setup.isEditButtonFocused && !_setup.isMoreActionsButtonFocused,
            },
          ]}):_vm._e(),_vm._v(" "),_c(_setup.OzPlainButton,{directives:[{name:"emit-click-on-touch",rawName:"v-emit-click-on-touch"}],class:[
            'post-actions-button',
            'shrink-0',

            // Want: 10px between 3 dots at the edge.
            // Assume 3 dots width is 2px.
            // DistanceFromEdge - (IconWidth - 3DotsWidth) / 2 = 10px - (16px - 2px) / 2 = 10px - 7px = 3px

            !_setup.isTouchable && [
              // ContainerHeight - ContainerMargin = 29px - 3px = 26px
              'h-[26px]',
              'w-5.5',
              'py-0',
              'px-[3px]',
            ],
            _setup.isTouchable && [
              'w-[48px]',
              // 42px is the minimum height of the post, hence maximum height of the button.
              'h-[42px]',
              // Total = 48px - 16px = 32px
              'pl-[29px] pr-[3px] rtl:pr-[29px] rtl:pl-[3px]',
              // Total = 42px - 16px - 3px = 23px. We have to omit the top padding.
              'pt-[3px] pb-[20px]',
            ],
            // Focus
            _vm.colorScheme === 'light' && 'focus-visible:text-grape-500 focus-visible:border-grape',
            _vm.colorScheme === 'dark' && 'focus-visible:text-canary-500 focus-visible:border-canary',
            'border-2 focus-visible:border-solid border-transparent rounded-lg',
            'flex items-center justify-center',
          ],attrs:{"color-scheme":_setup.OzPlainButtonColorScheme.SecondaryIcon,"dark-mode":_vm.colorScheme === 'dark',"size-preset":null,"aria-label":_vm.__('More post actions'),"title":_vm.__('More post actions'),"data-testid":"surfacePostMoreActionsButton"},on:{"click":_setup.onMoreActionsButtonClick,"focus":function($event){_setup.isMoreActionsButtonFocused = true},"blur":function($event){_setup.isMoreActionsButtonFocused = false}}},[_c(_setup.OzIcon,{attrs:{"name":"more_vertical","size":16}})],1)],1)]),_vm._v(" "),(_vm.xOverlay && !_setup.isWishContentScrollable)?_c('div',{class:[
        {
          absolute: true,
          'bottom-[-4px] ltr:right-[7px] rtl:left-[7px]': !_setup.isStream,
          'bottom-[-4px] ltr:right-[11px] rtl:left-[11px]': _setup.isStream,
          'rtl:-scale-x-100': true,
          [_setup.cornerColorClass]: true,
          'opacity-0': !_vm.xFillerElements || _setup.isMoreActionsButtonFocused,
        },
      ]}):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }